<div>
  <div class="flex items-center justify-between mb-2">
    <span class="text-xl font-bold">Notifications</span>
    <div class="flex items-center gap-2">
      @if (notifications?.length) {
        <button
          class="bg-primary-500 py-1 px-3 rounded-md text-white text-xs"
          (click)="clearAll()">
          Clear All
        </button>
      }
      <button
        class="bg-red-500 py-1 px-2 rounded-md text-white"
        (click)="closeModal(false)">
        <mat-icon svgIcon="close" style="height: 12px; width: 12px;"></mat-icon>
      </button>
    </div>
  </div>
  <div class="flex gap-1 mb-3">
    @for (tab of tabs; track tab) {
      @if (tab?.value === activeTab) {
        <div class="px-3 py-1 rounded-full bg-primary-500 text-white">
          {{ tab?.name }}
        </div>
      } @else {
        <div (click)="changeTab(tab.value)" class="px-3 py-1 rounded-full cursor-pointer hover:bg-primary-50">
          {{ tab?.name }}
        </div>
      }
    }
  </div>
  <div class="hidden-scrollbar flex flex-col divide-y">
    @for (notification of notifications; track notification) {
      <div (click)="openNotification(notification)"
        [ngClass]="{'bg-gray-100': !notification?.isRead }"
        class="flex items-start gap-2 p-3 mb-1 hover:bg-gray-50 cursor-pointer">
        <div class="w-10 h-10">
          <mat-icon class="text-gray-500">info</mat-icon>
        </div>
        <div class="flex flex-col">
          <span>{{ notification?.message }}</span>
          <span class="text-xs italic text-muted">
            {{ notification?.createdAt | formatDate : 'DD MMM, YYYY HH:mm' }}
          </span>
        </div>
      </div>
    }
  </div>
  <div class="flex mt-2 items-center justify-between">
    <div>
      @if (currentPage?.hasPreviousPage) {
        <span (click)="loadData(currentPage?.number-1)" class="text-muted cursor-pointer">
          <app-font-awesome-icon iconName="chevron-left"></app-font-awesome-icon>
          Prev Page
        </span>
      }
    </div>
    <div>
      @if (currentPage?.hasNextPage) {
        <span (click)="loadData(currentPage?.number+1)" class="text-muted cursor-pointer">
          Next Page
          <app-font-awesome-icon iconName="chevron-right"></app-font-awesome-icon>
        </span>
      }
    </div>

<!--    <span class="text-primary-400">Mark All As Read</span>-->
  </div>
</div>
